import { useState, useEffect } from 'react';

/**
 * Hook to detect scroll direction and manage visibility
 * Returns whether element should be visible based on scroll behavior
 */
const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState('up');
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Always show when at the top
      if (currentScrollY < 10) {
        setVisible(true);
        setPrevScrollY(currentScrollY);
        return;
      }

      // Determine scroll direction
      if (currentScrollY > prevScrollY && currentScrollY > 100) {
        // Scrolling down
        setScrollDirection('down');
        setVisible(false);
      } else if (currentScrollY < prevScrollY) {
        // Scrolling up
        setScrollDirection('up');
        setVisible(true);
      }

      setPrevScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollY]);

  return { scrollDirection, visible };
};

export default useScrollDirection;
